import React from 'react';

import styles from './loader-dots.module.css';

const LoaderDots = () => {

  return (
    <div className={styles.loader} />
  );
};

export default LoaderDots;
